import React, { useCallback, useEffect, useRef, useState } from "react"
import { RowModule } from "../../../../../../../component/atoms/RowModule/RowModule.jsx"
import { Card, CardBody } from "../../../../../../../_metronic/_partials/controls/index.js"
import TableView, {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../../../_metronic/_helpers/index.js"
import { Button } from "react-bootstrap"
import { loadUserLogin } from "../../../../../../service/userManagementAction.js"
import { useDispatch, useSelector } from "react-redux"
import { useSubheader } from "../../../../../../../_metronic/layout/index.js"
import {
  CheckboxLabelButton,
  EmptyCard,
  Search,
  TableSkeleton
} from "../../../../../../../component/index.jsx"
import {
  getCategoryItemList,
  getPlantType
} from "../../../../../../../redux/actions/MasterDataAction.jsx"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../../../../constants/PrivilegeConstants.js"
import { RoutesConstants } from "../../../../../../../constants/RoutesConstants.js"

export const DetailSeed = ({
  history,
  match: {
    params: { subType }
  }
}) => {
  const privileges = loadUserLogin().privilege
  const subHeader = useSubheader()
  const { t } = useTranslation()
  const { General, MasterData } = useSelector((state) => state)
  const [search, setSearch] = useState({
    string_filter: ""
  })
  const formRef = useRef()
  const dispatch = useDispatch()
  const [statusValue, setStatusValue] = useState([])
  const [isStatus, setIsStatus] = useState([])

  const changePage = useCallback(
    (param) => {
      let newParam = {
        ...search,
        ...param,
        plant_type_id: statusValue
      }
      if (param.sortField) {
        newParam = {
          ...newParam,
          sort: param.sortField + "," + param.sortOrder
        }
      }
      dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: newParam }))
    },
    [dispatch, search, statusValue]
  )

  useEffect(() => {
    dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: initialFilterTable }))
    dispatch(getPlantType())
  }, [])

  useEffect(() => {
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.MASTER_DATA.CATEGORY_ITEM.PAGE(),
        title: t("sub_header_category_item")
      },
      {
        title: t("sub_header_seed")
      }
    ])
    if (privileges.indexOf(PRIVILEGE_ENUM.MODIFIED_CATEGORY_ITEM) > -1) {
      subHeader.setButton(
        <Button
          variant="primary"
          onClick={() => {
            history.push(RoutesConstants.MASTER_DATA.CATEGORY_ITEM.NEW_ITEM_WITH_SUBTYPE("seed", subType))
          }}>
          Tambah
        </Button>
      )
    } else {
      subHeader.setButton(null)
    }
    subHeader.setTitle(t("sub_header_seed"))
  }, [])

  useEffect(() => {
    let param = {
      ...initialFilterTable,
      string_filter: search.string_filter,
      plant_type_id: statusValue
    }
    dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: param }))
  }, [statusValue])

  useEffect(() => {
    if (MasterData.plantType) {
      let newPlantType = []
      MasterData.plantType.map((item) => {
        let newtype = {
          label: item.name,
          enum: item.id,
          checked: false
        }
        newPlantType.push(newtype)
      })
      setIsStatus(newPlantType)
    }
  }, [MasterData.plantType])

  const uiDate = (e) => {
    return (
      <>
        <div className="mb-1">{e?.submitted_date ? e?.submitted_date : "-"}</div>
        <div>{e?.submitted_time ? e?.submitted_time : "-"}</div>
      </>
    )
  }

  const uiType = (e) => {
    return <>{e.plant_type_name ?? "-"}</>
  }

  const uiUnit = (e) => {
    return <>{e.unit_name ?? "-"}</>
  }

  const columns = [
    {
      dataField: "name",
      text: t("table_header_variant_name"),
      formatter: formatterRowComponent
    },
    {
      dataField: "plantType",
      text: t("table_header_planting_type"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiType
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          sort: field + "," + order
        }
        dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: param }))
      }
    },
    {
      dataField: "unit_name",
      text: "UNIT",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiUnit
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_submitted_date"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDate
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret,
      sort: true,
      onSort: (field, order) => {
        let param = {
          ...initialFilterTable,
          sort: field + "," + order
        }
        dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: param }))
      }
    }
  ]

  const onSubmitForm = (values) => {
    let param = {
      ...initialFilterTable,
      string_filter: values.string_filter,
      plant_type_id: statusValue
    }
    setSearch({
      string_filter: values.string_filter
    })
    dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: param }))
  }

  const trigerReset = () => {
    setSearch({
      string_filter: ""
    })
    let param = {
      ...initialFilterTable,
      string_filter: "",
      plant_type_id: statusValue
    }
    dispatch(getCategoryItemList(subType.toUpperCase(), { pageReq: param }))
  }

  const handleStatus = (e) => {
    const { checked, value } = e.target
    if (checked) {
      setStatusValue(value)
    }
  }

  const onResetRadio = () => {
    setStatusValue("")
  }

  return (
    <>
      <div className="filter-container">
        <div className="position-relative d-flex flex-wrap justify-content-between align-items-center mb-10">
          <Search
            placeholder={t("placeholder_insert_variant_name")}
            onSubmitForm={onSubmitForm}
            initialValues={search}
            name={"string_filter"}
            innerRef={formRef}
            trigerReset={trigerReset}
          />
          <CheckboxLabelButton
            onCLickRadioReset={onResetRadio}
            type={"radio"}
            formInitialValues={statusValue}
            isStatus={isStatus}
            name={"plant_type_id"}
            innerRef={formRef}
            handleChange={handleStatus}
          />
        </div>
      </div>

      <Card>
        <RowModule>
          <Card className="card-shadowless">
            <CardBody>
              {General?.loading ? (
                <TableSkeleton column={4} row={10} />
              ) : MasterData?.pageData?.length == 0 ? (
                <EmptyCard
                  body={
                    search?.string_filter?.length > 0 || statusValue.length > 0
                      ? t("messages_response_data_not_found")
                      : t("messages_response_empty_state")
                  }
                />
              ) : (
                ""
              )}

              <TableView
                callbackAfterPageChange={changePage}
                columnProperties={columns}
                dataTable={MasterData?.pageData}
                currentPage={MasterData?.page?.currentPage}
                currentElement={MasterData?.page?.currentElement}
                totalCount={MasterData?.page?.totalCount}
                loadingGetData={General.loading}
                rowClasses={() => {
                  return "cursor-default"
                }}
              />
            </CardBody>
          </Card>
        </RowModule>
      </Card>
    </>
  )
}